import contract_action_type from "dictionaries/contract_action_type.json";
import createOptions from "utils/createOptions";

export default createOptions(contract_action_type);
